/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Daylist
 */
export interface Daylist {
    /**
     * 
     * @type {number}
     * @memberof Daylist
     */
    dateno: number | null;
    /**
     * 
     * @type {string}
     * @memberof Daylist
     */
    rectype: string | null;
    /**
     * 
     * @type {number}
     * @memberof Daylist
     */
    weekNo: number | null;
    /**
     * 
     * @type {string}
     * @memberof Daylist
     */
    colname: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Daylist
     */
    datevalue: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Daylist
     */
    rectypeName: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Daylist
     */
    orderDate: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof Daylist
     */
    newitemStartFlg: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Daylist
     */
    renewalNumber: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Daylist
     */
    isOrderConfirmed: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Daylist
     */
    isOrderToday: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Daylist
     */
    isUpdatedArrivalTmp: boolean | null;
}

/**
 * Check if a given object implements the Daylist interface.
 */
export function instanceOfDaylist(value: object): value is Daylist {
    if (!('dateno' in value) || value['dateno'] === undefined) return false;
    if (!('rectype' in value) || value['rectype'] === undefined) return false;
    if (!('weekNo' in value) || value['weekNo'] === undefined) return false;
    if (!('colname' in value) || value['colname'] === undefined) return false;
    if (!('datevalue' in value) || value['datevalue'] === undefined) return false;
    if (!('rectypeName' in value) || value['rectypeName'] === undefined) return false;
    if (!('orderDate' in value) || value['orderDate'] === undefined) return false;
    if (!('newitemStartFlg' in value) || value['newitemStartFlg'] === undefined) return false;
    if (!('renewalNumber' in value) || value['renewalNumber'] === undefined) return false;
    if (!('isOrderConfirmed' in value) || value['isOrderConfirmed'] === undefined) return false;
    if (!('isOrderToday' in value) || value['isOrderToday'] === undefined) return false;
    if (!('isUpdatedArrivalTmp' in value) || value['isUpdatedArrivalTmp'] === undefined) return false;
    return true;
}

export function DaylistFromJSON(json: any): Daylist {
    return DaylistFromJSONTyped(json, false);
}

export function DaylistFromJSONTyped(json: any, ignoreDiscriminator: boolean): Daylist {
    if (json == null) {
        return json;
    }
    return {
        
        'dateno': json['dateno'],
        'rectype': json['rectype'],
        'weekNo': json['week_no'],
        'colname': json['colname'],
        'datevalue': (json['datevalue'] == null ? null : new Date(json['datevalue'])),
        'rectypeName': json['rectype_name'],
        'orderDate': (json['order_date'] == null ? null : new Date(json['order_date'])),
        'newitemStartFlg': json['newitem_start_flg'],
        'renewalNumber': json['renewal_number'],
        'isOrderConfirmed': json['is_order_confirmed'],
        'isOrderToday': json['is_order_today'],
        'isUpdatedArrivalTmp': json['is_updated_arrival_tmp'],
    };
}

export function DaylistToJSON(json: any): Daylist {
    return DaylistToJSONTyped(json, false);
}

export function DaylistToJSONTyped(value?: Daylist | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dateno': value['dateno'],
        'rectype': value['rectype'],
        'week_no': value['weekNo'],
        'colname': value['colname'],
        'datevalue': value['datevalue'] == null ? value['datevalue'] : value['datevalue'].toISOString(),
        'rectype_name': value['rectypeName'],
        'order_date': value['orderDate'] == null ? value['orderDate'] : value['orderDate'].toISOString().substring(0,10),
        'newitem_start_flg': value['newitemStartFlg'],
        'renewal_number': value['renewalNumber'],
        'is_order_confirmed': value['isOrderConfirmed'],
        'is_order_today': value['isOrderToday'],
        'is_updated_arrival_tmp': value['isUpdatedArrivalTmp'],
    };
}

